export const RouteKeyGenerator = {} as { key: number };
let counter = 1;
Object.defineProperty(RouteKeyGenerator, 'key', { get: () => counter++ });
